import WithoutSidebar from "../../layouts/WithOutSidebar";
import "./callback.css";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ShareIcon from "@mui/icons-material/Share";
import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import {exportAsImage, shareImage} from "../../scripts/export";

const Callback = () => {
  const [transactionData, setTransactionData] = useState();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useSearchParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const success = params.get("success") === "true";
  const error = params.get("error");
  const transactionId = params.get("id");
  const rrn = params.get("rrn");
  const exportRef = useRef();
  const transactionVerify = async () => {
    setLoading(true);
    const res = await ajax({
      method: "GET",
      url: utils.urls.transactionVerify(transactionId, rrn),
      snackbar: enqueueSnackbar,
    }).catch((e) => {
      console.log("ERR:callbackPage:verifyTransaction", e);
    });
    if (res && res.data) {
      setTransactionData(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (success && transactionId && rrn) {
      transactionVerify();
    }
  }, []);
  return (
    <WithoutSidebar footer={true} isLogin={true}>
      <div
        className="callback-container"
        // style={{ backgroundImage: "url(/images/bg-home.jpg)" }}
      >
        {success ? (
          <>
            <div className="callback-container__background"></div>
            {loading && !transactionData ? (
              <div className="container">
                <div className="callback-box-loading">
                  <div className="callback-box__header">
                    <div>
                      <p>در حال بارگذاری</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : transactionData ? (
              <div ref={exportRef} className="container">
                <div className="callback-box">
                  <div className="callback-box__header">
                    <div>
                      <CheckCircleOutlineIcon />
                      <p>پرداخت با موفقیت انجام شد</p>
                    </div>
                  </div>
                  {/* <div className="callback-box__title">
              <p>شما در حال پرداخت هزینه صدور بلیط</p>
              <p> شرکت هواپیمایی ایران ایر هستید</p>
            </div> */}
                  <div className="payment">
                    <div className="tickets">
                      <div className="label"> مبلغ</div>
                      <div className="amounts">
                        <p style={{ direction: "rtl" }}>
                          {utils.e2p(transactionData.amount.toLocaleString())}{" "}
                          ریال
                        </p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> بابت</div>
                      <div className="amounts">
                        <p>{utils.services[transactionData.product.name]}</p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> تاریخ و زمان</div>
                      <div className="amounts">
                        <p>{utils.g2j(transactionData.dateTime)}</p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> کد پیگیری هما</div>
                      <div className="amounts">
                        <p>{transactionData.id}</p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> کد پیگیری</div>
                      <div className="amounts">
                        <p>{transactionData.traceNo}</p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> کد پیگیری درگاه پرداخت </div>
                      <div className="amounts">
                        <p>{transactionData.pgwReference}</p>
                      </div>
                    </div>
                    <div className="tickets">
                      <div className="label"> شماره ارجاع</div>
                      <div className="amounts">
                        <p>{transactionData.rrn}</p>
                      </div>
                    </div>
                  </div>
                  <div className="wrapper-btn">
                    <button className="callback-share__btn"
                      onClick={() =>
                        shareImage(exportRef.current, "iran-air-receipt.png")
                      }
                    >
                      {" "}
                      به اشتراک گذاری رسید <ShareIcon />
                    </button>
                    <button
                      className="callback-box__btn"
                      onClick={() =>
                        exportAsImage(exportRef.current, "iran-air-receipt")
                      }
                    >
                      {" "}
                      ذخیره رسید <SaveAltIcon />
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : !success ? (
          <>
            <div className="callback-container__background"></div>
            <div className="container">
              <div className="callback-box-error">
                <div className="callback-box__header-error">
                  <div>
                    <ErrorOutlineIcon />
                    <p>تراکنش ناموفق!</p>
                  </div>
                </div>
                <div className="payment">{error}</div>
                <div className="wrapper-btn">
                  <button
                    className="callback-share__btn"
                    onClick={() => navigate(`/`, { replace: true })}
                  >
                    {" "}
                    صفحه اصلی <HomeIcon />
                  </button>
                  <button
                    className="callback-box__btn"
                    onClick={() =>
                      navigate(`/${transactionId}`, { replace: true })
                    }
                  >
                    {" "}
                    سعی مجدد
                    <RefreshIcon />
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </WithoutSidebar>
  );
};
export default Callback;
